{
  "open": "Administration",
  "backProfile": "Back to profile",
  "backList": "Back to the list",
  "saved": "Change saved",
  "saveFailed": "Couldn’t save",
  "catalogCreated": "Catalog entry created",
  "createFailed": "Couldn’t create entry",
  "catalogDeleted": "Catalog entry deleted",
  "deleteFailed": "Couldn’t delete entry",
  "deleteAnime": "Delete work",
  "deleteCharacter": "Delete character",
  "confirmDeleteAnime": "Permanently delete “{{name}}” and all its characters, owned cards, listings, auctions, trades, and completions? This action cannot be undone.",
  "confirmDeleteCharacter": "Permanently delete “{{name}}”, including owned cards, listings, auctions, trades, and profile references? This action cannot be undone.",
  "addAnime": "Add a work",
  "addCharacter": "Add character to this series",
  "animeTitle": "Title",
  "animeType": "Work type",
  "animeTypeAnime": "Anime",
  "animeTypeManga": "Manga",
  "animeTypeNovel": "Novel",
  "animeTypeVideoGame": "Video game",
  "animeTypeCinematography": "Cinematography",
  "coverImageUrl": "Cover image URL",
  "bannerImageUrl": "Banner image URL",
  "characterName": "Character name",
  "characterImageUrl": "Character image URL",
  "allowedImageHosts": "Allowed hosts: s4.anilist.co, zupimages.net, or the ANIDEX image library.",
  "rarity": "Rarity",
  "role": "Role",
  "rarities": {
    "common": "Common",
    "uncommon": "Uncommon",
    "rare": "Rare",
    "epic": "Epic",
    "legendary": "Legendary",
    "mythic": "Mythic",
    "divine": "Divine",
    "senita": "Senita"
  },
  "requested": "Request sent",
  "requestFailed": "Couldn’t send the request",
  "approved": "Permission granted",
  "denied": "Request refused",
  "revoked": "Permission removed",
  "nav": {
    "label": "Administration",
    "board": "Board",
    "anime": "Works",
    "characters": "Characters",
    "players": "Players",
    "roles": "Roles",
    "requests": "Requests",
    "reports": "Reports",
    "content": "Content",
    "animations": "Animations",
    "missingImages": "Missing images"
  },
  "contentPage": {
    "title": "Content",
    "overview": "Overview",
    "titles": "Titles",
    "badges": "Badges",
    "frames": "Frames",
    "avatars": "Avatars",
    "banners": "Banners",
    "achievements": "Achievements",
    "quests": "Quests",
    "search": "Search",
    "tier": "Tier",
    "allTiers": "All tiers",
    "owners_one": "{{count}} owns it",
    "owners_other": "{{count}} own it",
    "worn_one": "{{count}} wears it",
    "worn_other": "{{count}} wear it",
    "unlockedBy_one": "{{count}} player",
    "unlockedBy_other": "{{count}} players",
    "reached_one": "{{count}} already earned by at least one player",
    "reached_other": "{{count}} already earned by at least one player",
    "rewardOptions_one": "{{count}} possible reward",
    "rewardOptions_other": "{{count}} possible rewards",
    "coverage": "Coverage",
    "coverageOk": "Every cosmetic is granted by an achievement tier.",
    "objectives": "Objectives",
    "effort": "effort {{effort}}",
    "from": "Granted by",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "animate": "Animated",
    "static": "Static",
    "preview": "Fitting room",
    "weight": "Weight {{weight}}",
    "rewards": "Possible rewards",
    "cosmeticTracks_one": "{{count}} achievement grants a cosmetic every {{step}} tiers",
    "cosmeticTracks_other": "{{count}} achievements grant a cosmetic every {{step}} tiers",
    "tierTargets": "Tiers 1, 2, 3, 5, 10: {{targets}}",
    "maxTier": "Highest tier: {{tier}}"
  },
  "range": {
    "label": "Range",
    "days": "{{count}} days"
  },
  "premium": {
    "title": "Premium",
    "activeUntil": "Active until {{until}}",
    "inactive": "No active Premium.",
    "duration": "Premium duration (days)",
    "grant": "Grant Premium",
    "granted": "Premium granted",
    "logs": "Premium logs",
    "noLogs": "No Premium granted manually.",
    "sourceFree": "Free",
    "logLine": "{{days}} days · until {{until}} · by {{by}}"
  },
  "players": {
    "intro": "Search for a player to review their economy, Premium, roles and permissions.",
    "caption": "Player list",
    "empty": "No player found.",
    "never": "Never",
    "columns": {
      "player": "Player",
      "level": "Level",
      "anima": "Anima",
      "cards": "Cards",
      "status": "Status",
      "lastLogin": "Last login"
    },
    "status": {
      "active": "Active",
      "blocked": "Blocked"
    }
  },
  "player": {
    "tabsLabel": "Player sections",
    "tabs": {
      "account": "Account",
      "premium": "Premium",
      "economy": "Economy",
      "roles": "Roles",
      "permissions": "Permissions",
      "data": "Data"
    },
    "info": "Information",
    "actions": "Actions",
    "level": "Level",
    "anima": "Anima",
    "cards": "Cards",
    "email": "Email",
    "verification": "Email verified",
    "status": "Status",
    "owner": "Owner"
  },
  "data": {
    "edit": "Edit player data",
    "username": "Username",
    "anima": "Anima balance",
    "xp": "XP",
    "save": "Save",
    "saved": "Data saved",
    "nothingToSave": "Nothing to save",
    "reset": "Reset",
    "resetHint": "Choose what to reset. A full reset restores the fresh-account state while keeping identity and Premium.",
    "resetScopes": {
      "achievements": {
        "label": "Achievements",
        "confirm": "Clear all of this player's achievements?",
        "done": "Achievements reset"
      },
      "collection": {
        "label": "Collection",
        "confirm": "Empty this player's collection (cards and fragments)?",
        "done": "Collection reset"
      },
      "level": {
        "label": "Level",
        "confirm": "Reset level and XP?",
        "done": "Level reset"
      },
      "anima": {
        "label": "Anima",
        "confirm": "Reset the Anima balance to zero?",
        "done": "Anima reset"
      },
      "all": {
        "label": "All data",
        "confirm": "Reset ALL of this player's game data? This cannot be undone.",
        "done": "Data reset"
      }
    }
  },
  "playerEconomy": {
    "title": "Anima and rewards",
    "allTime": "All history",
    "currentBalance": "Current balance",
    "received": "Anima received",
    "spent": "Anima sent",
    "net": "Net change in this period",
    "flow": "Anima inflows and outflows",
    "flowHint": "Flows include holds and their refunds, which are not new rewards.",
    "sources": "Where does the Anima come from?",
    "sourcesHint": "Anima received, broken down by source.",
    "daily": "Daily totals, in UTC.",
    "monthly": "Monthly totals, in UTC.",
    "chartData": "View chart amounts",
    "period": "Period",
    "history": "Player history",
    "ledger": "Anima journal",
    "rewards": "Rewards",
    "refresh": "Refresh histories",
    "source": "Source",
    "allSources": "All sources",
    "date": "Date (UTC)",
    "amount": "Movement",
    "balanceAfter": "Balance after",
    "direction": "Movement direction",
    "directions": {
      "all": "All",
      "in": "Incoming",
      "out": "Outgoing"
    },
    "reference": "Reference",
    "rewardReference": "Grant details",
    "ledgerHint": "Each movement shows its source and the balance immediately afterwards. Journal filters do not change the charts.",
    "rewardsHint": "Rewards actually received: Anima, EXP, boosters, cards, fragments and cosmetics. Values are the amounts granted at the time.",
    "noMovements": "No movements to display.",
    "noIncome": "No Anima received in this period.",
    "noRewards": "No rewards match these filters.",
    "emptyHint": "Change the period or filters to find other events.",
    "loaded": "{{loaded}} of {{total}} events displayed",
    "level": "Level {{level}}",
    "sponsor": "Sponsor: {{name}}",
    "characterId": "Character #{{id}}",
    "duplicate": "Duplicate converted into {{amount}} fragments for {{name}}.",
    "cardGranted": "Card received: {{name}}.",
    "ledgerTypes": {
      "signup_bonus": "Signup bonus",
      "booster_purchase": "Booster purchase",
      "quest_reward": "Quest reward",
      "achievement_reward": "Achievement reward",
      "level_reward": "Level reward",
      "login_reward": "Calendar reward",
      "admin_adjustment": "Administrative adjustment",
      "market_purchase": "Card purchase",
      "market_sale": "Card sale",
      "system_sale": "System buyback",
      "auction_hold": "Auction hold",
      "auction_refund": "Auction refund",
      "trade_hold": "Trade hold",
      "trade_release": "Trade release",
      "trade_payment": "Trade payment",
      "trade_received": "Anima received in a trade",
      "fragment_conversion": "Fragment conversion",
      "anime_completion": "Series completed",
      "harvest_payout": "Anima harvest",
      "referral_bonus": "Referral bonus"
    },
    "rewardTypes": {
      "signup": "Signup bonus",
      "quest": "Quest",
      "achievement": "Achievement",
      "level": "Level",
      "login": "Calendar",
      "anime": "Series completed",
      "referral": "Referral",
      "harvest": "Harvest"
    }
  },
  "metrics": {
    "circulation": "Anima in circulation",
    "circulationHint": "Sum of balances on accounts that are still open.",
    "spend": "Player spending",
    "spendHint": "Boosters bought and market purchases. Holds are not spending.",
    "boosters": "Boosters",
    "market": "Market",
    "harvest": "Harvest pot",
    "harvestHint": "The open month’s pot, and what entered it each day.",
    "harvestAdded": "{{amount}} added in this range",
    "month": "Month {{month}}",
    "noMonth": "No open harvest",
    "daily": "Day by day",
    "emptyChart": "No movement in this range."
  },
  "search": "Search",
  "searchAnime": "Title",
  "searchCharacter": "Name",
  "searchPlayer": "Username or email",
  "more": "Show more",
  "charactersCount": "{{count}} characters",
  "pickAnime": "Pick a work to show its cast.",
  "castEmpty": "This work has no characters.",
  "pickField": "Pick a work or a character to open its file.",
  "inspector": "File",
  "save": "Save",
  "request": "Request permission",
  "pending": "Pending",
  "yes": "Yes",
  "no": "No",
  "revoke": "Revoke",
  "block": "Block",
  "unblock": "Unblock",
  "blocked": "Player blocked",
  "unblocked": "Player unblocked",
  "add": "Add",
  "remove": "Remove",
  "create": "Create role",
  "rename": "Rename",
  "deleteRole": "Delete role",
  "roleName": "Role name",
  "username": "Username",
  "animeId": "Work ID",
  "members": "Players",
  "assigned": "Assigned works",
  "noMembers": "No player on this role.",
  "noAnime": "No work assigned.",
  "grants": "Granted permissions",
  "noGrants": "No extra permission.",
  "rolesOf": "Roles",
  "noRoles": "No role.",
  "status": "Status",
  "level": "Level {{level}}",
  "lastLogin": "Last sign-in",
  "never": "Never",
  "verified": "Email verified",
  "unverified": "Email not verified",
  "owner": "Owner",
  "requestFrom": "{{who}} asks to edit {{field}}",
  "onEntity": "on {{name}}",
  "fields": {
    "id": "Id",
    "title": "Name",
    "title_english": "English name",
    "title_native": "Original name",
    "cover_url": "Image",
    "cover_medium_url": "Medium image",
    "banner_url": "Banner",
    "favourites": "Favorites",
    "type": "Type",
    "format": "Format",
    "status": "Status",
    "season_year": "Year",
    "cover_color": "Color",
    "popularity": "Popularity",
    "is_adult": "Adult",
    "rank": "Rank",
    "character_count": "Obtainable characters",
    "synced_at": "Last sync",
    "created_at": "Created",
    "name": "Name",
    "name_native": "Original name",
    "image_url": "Image",
    "image_medium_url": "Medium image",
    "role": "Role in the work",
    "rarity": "Rarity",
    "value": "Value",
    "is_obtainable": "Obtainable",
    "anime_id": "Linked work",
    "__delete": "deletion"
  },
  "banIp": "Ban IP",
  "banIpReason": "Address ban",
  "ipBanned": "Address banned",
  "ips": "Addresses",
  "reports": {
    "filter": "Report status",
    "messageSnapshot": "Content at the time of the report",
    "deletedMessage": "Deleted message",
    "nickname": "Nickname: {{text}}",
    "signature": "Signature: {{text}}",
    "empty": "No reports in this list.",
    "ban": "Ban",
    "banIp": "Ban IP",
    "dismiss": "Dismiss",
    "status": {
      "open": "Open",
      "resolved": "Handled",
      "dismissed": "Dismissed"
    },
    "reason": {
      "spam": "Spam",
      "harassment": "Harassment",
      "inappropriate": "Inappropriate",
      "impersonation": "Impersonation",
      "other": "Other"
    },
    "done": {
      "ban": "Player banned",
      "ban_ip": "Address banned",
      "dismiss": "Report dismissed"
    }
  },
  "adultYes": "Yes",
  "adultNo": "No",
  "obtainableYes": "Yes",
  "obtainableNo": "No",
  "none": "None",
  "missingImages": {
    "title": "Missing images",
    "lead": "",
    "totals_one": "{{count}} character to fill in",
    "totals_other": "{{count}} characters to fill in",
    "rankingTitle": "Contributor leaderboard",
    "rankingLead": "",
    "rankingEmpty": "No contributors yet.",
    "rankingCount_one": "{{formatted}} image",
    "rankingCount_other": "{{formatted}} images",
    "search": "Search a character or work",
    "cover": "Cover",
    "banner": "Banner",
    "applied": "Image applied: {{name}}",
    "empty": "No missing images here 🎉",
    "done": "Image OK",
    "none": "No image",
    "works_one": "{{count}} work without cover or banner",
    "works_other": "{{count}} works without cover or banner",
    "workTotals": "{{count}} / {{total}} characters without image",
    "workImages": "Work images",
    "noCharacters": "No characters in this work.",
    "deleteRequest": "Request deletion",
    "deletePending": "Deletion requested",
    "deleteRequested": "Deletion request sent: {{name}}",
    "confirmDeleteCharacter": "Send a deletion request for “{{name}}”? An owner will have to approve it in Requests.",
    "confirmDeleteAnime": "Send a deletion request for the work “{{name}}” and its whole cast? An owner will have to approve it in Requests.",
    "statusLabel": "Filter by image state",
    "status": {
      "missing": "Without image",
      "done": "With image",
      "all": "All"
    },
    "emptyDone": "No characters with an image here.",
    "rarity": "Rarity of {{name}}",
    "rarityChanged": "{{name}}: {{rarity}} (value {{value}})"
  },
  "webSuggestions": {
    "toggle": "Web suggestions",
    "lead": "Click a suggestion to download it.",
    "query": "Search",
    "search": "Search",
    "loading": "Searching…",
    "empty": "No images found.",
    "emptyFormat_one": "No image in the right format ({{count}} discarded).",
    "emptyFormat_other": "No image in the right format ({{count}} discarded).",
    "showAll_one": "Also show {{count}} off-format image",
    "showAll_other": "Also show {{count}} off-format images",
    "hideOff": "Hide off-format images",
    "offFormat": "Off format",
    "pick": "Use this image ({{width}} × {{height}})",
    "importing": "Importing…",
    "license": {
      "check": "Check licenses",
      "checking": "Checking…",
      "free": "Free",
      "restricted": "Not free",
      "freeHint": "Creative Commons license allowing commercial use and modification, according to Google. Check the license and required attribution on the source page.",
      "restrictedHint": "No free license detected: rights are probably reserved (studio, publisher or artist). Use only with permission."
    },
    "unavailable": "Google search is not responding. Try again later.",
    "nothingMissing": "No missing images on this page.",
    "format": {
      "image": "Card · portrait",
      "cover": "Cover · portrait",
      "banner": "Banner · landscape"
    }
  },
  "media": {
    "url": "Image URL",
    "title": "Image library",
    "hint": "Pick an image you already saved or upload a new one (PNG, JPEG, WebP, GIF, AVIF).",
    "library": "Open the image library",
    "upload": "Upload an image",
    "uploading": "Uploading…",
    "uploaded": "Image saved",
    "uploadFailed": "Upload failed",
    "dropHint": "or drop an image here",
    "dropUnsupported": "Drop an image file (PNG, JPEG, WebP, GIF, AVIF) or an image from a web page.",
    "empty": "No saved images yet.",
    "unnamed": "Untitled"
  },
  "animations": {
    "title": "Animations",
    "lead": "Replay a booster reveal exactly like a real pull, without spending or receiving anything.",
    "play": "Play animation",
    "rarity": "Pulled rarity",
    "cardLevel": "Card level",
    "level": "Level {{level}}",
    "options": "Staging",
    "booster": "Booster",
    "boosters": {
      "free": "Free booster",
      "standard": "Standard booster",
      "premium": "Premium booster",
      "legendary": "Legendary booster"
    },
    "fullPack": "Full pack (5 cards, chosen rarity last)",
    "duplicate": "Duplicate (fragments instead of a new card)",
    "pity": "Pity guarantee",
    "character": "Character",
    "sampleName": "Test character",
    "sampleHint": "By default the card uses your avatar. Search a character to use its picture.",
    "using": "Playing with {{name}}.",
    "reset": "Remove"
  },
  "deleteRequestCharacter": "{{who}} asks to delete the character {{name}}",
  "deleteRequestAnime": "{{who}} asks to delete the work {{name}} (and its whole cast)",
  "deleteRequestWarning": "Approving permanently deletes the entry and refunds the players who own it.",
  "deleteRequestApprove": "Delete",
  "deleteRequestConfirm": "Permanently delete “{{name}}”?",
  "deleteRequestDone": "Entry deleted"
}
